// 该文件为针对小程序的特殊处理
!(function () {
    common.isFromXCXDef(function (res) {
        if(res){
            $('.bottombox').hide(); //底部导航
        }
    });
})();

